import * as React from "react";
import {
  Grid,
  TextField,
  MenuItem,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Box,
  Checkbox,
  FormGroup,
  Switch,
} from "@mui/material";
import { ordinalize } from "../utils/StringHelper";
import { MONTHS } from "../globals/globals";
import { snakeCaseToTitleCase } from "../utils/CaseFormatHelper";
interface Props {
  readOnly: boolean;
  handleBooleanChange: any;
  handleStringChange: any;
  handleDayChange: any;
  recurrence?: any;
}


export const TIME_UNITS = ["day", "week"];
export const daysOfWeek = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];


const StandardRecurrenceForm: React.FC<Props> = (props: any) => {
  React.useEffect(() => {
  }, [])

return (
<Grid item container xs={12} style={{ margin: "25px 0 0 10px" }}>
            <Grid
              item
              xs={12}
              className="field-container"
              style={{ paddingBottom: 20, borderBottom: "1px solid #EFE9E7" }}
            >
              <FormControl component="fieldset">
                <b>This action should start on</b>
                <RadioGroup
                  aria-label="start_on_program_start"
                  name="start_on_program_start"
                  value={props.recurrence?.start_on_program_start}
                  onChange={props.handleBooleanChange}
                  style={{gap: '16px'}}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label={
                      <Box display="flex" alignItems="center">
                        Program start date
                      </Box>
                    }
                    disabled={props.readOnly}
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    disabled={props.readOnly}
                    label={
                      <Box display="flex" alignItems="center">
                        <TextField
                          id="start_after_program_start_value"
                          name="start_after_program_start_value"
                          size="small"
                          type="text"                         
                          value={props.recurrence?.start_after_program_start_value || ""}
                          className="the-field"
                          required
                          variant="outlined"
                          placeholder="Unit"
                          style={{ width: "5em", marginRight: "5px" }}
                          disabled={
                            props.readOnly ||
                            props.recurrence?.start_on_program_start
                          }
                          inputProps={{
                            maxLength: 10,                   
                            inputMode: "numeric",             
                            pattern: "[0-9]*"                 
                          }}
                          onChange={(e) => {
                            const raw = e.target.value;
                            const numeric = raw.replace(/\D/g, "");
                            const trimmed = numeric.slice(0, 10);
                            props.handleStringChange({
                              target: {
                                name: "start_after_program_start_value",
                                value: trimmed
                              }
                            });
                          }}
                        />
                        <TextField
                          id="start_after_program_start_unit"
                          name="start_after_program_start_unit"
                          onChange={props.handleStringChange}
                          size="small"
                          value={props.recurrence?.start_after_program_start_unit}
                          variant="outlined"
                          select
                          style={{ width: "6em", marginRight: "10px" }}
                          disabled={
                            props.readOnly ||
                            props.recurrence?.start_on_program_start
                          }
                          className="the-field"
                        >
                          <MenuItem value="" disabled>
                            Select
                          </MenuItem>
                          {TIME_UNITS.map((time) => (
                            <MenuItem key={time} value={time}>
                              {time}(s)
                            </MenuItem>
                          ))}
                        </TextField>{" "}
                        after program start date
                      </Box>
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              className="field-container"
              style={{
                padding: "20px 0 20px 0",
                borderBottom: "1px solid #EFE9E7",
              }}
            >
              <FormControl component="fieldset">
                <b>This action should repeat</b>
                <RadioGroup
                  aria-label="repeat"
                  name="repeat"
                  value={props.recurrence?.repeat}
                  onChange={props.handleBooleanChange}
                  style={{gap: '16px'}}
                >
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    disabled={props.readOnly}
                    label={
                      <Box display="flex" alignItems="center">
                        Does not repeat
                      </Box>
                    }
                  />
                  <FormControlLabel
                    value={true}
                    disabled={props.readOnly}
                    control={<Radio />}
                    label={
                      <Box display="flex" alignItems="center">
                        <span>Repeat every &nbsp; </span>
                        <TextField
                          id="repeat_value"
                          name="repeat_value"
                          type="text"        
                          size="small"
                          value={props.recurrence?.repeat_value || ""}
                          className="the-field"
                          required
                          variant="outlined"
                          placeholder="Unit"
                          style={{ width: "5em", marginRight: "5px" }}
                          disabled={props.readOnly || !props.recurrence?.repeat}
                          inputProps={{
                            maxLength: 10,  
                            inputMode: "numeric",               
                            pattern: "[0-9]*"                   
                          }}
                          onChange={(e) => {
                            const raw = e.target.value;
                            const numeric = raw.replace(/\D/g, "");
                            const trimmed = numeric.slice(0, 10);
                            props.handleStringChange({
                              target: {
                                name: "repeat_value",
                                value: trimmed
                              }
                            });
                          }}
                        />
                        <TextField
                          id="repeat_unit"
                          name="repeat_unit"
                          onChange={props.handleStringChange}
                          size="small"
                          value={props.recurrence?.repeat_unit}
                          variant="outlined"
                          select
                          style={{ width: "6em", marginRight: "10px" }}
                          disabled={props.readOnly || !props.recurrence?.repeat}
                          className="the-field"
                        >
                          <MenuItem value="" disabled>
                            Select
                          </MenuItem>
                          {TIME_UNITS.map((time) => (
                            <MenuItem key={time} value={time}>
                              {time}(s)
                            </MenuItem>
                          ))}
                        </TextField>
                      </Box>
                    }
                  />
                </RadioGroup>
                {props.recurrence?.repeat &&
                  props.recurrence?.repeat_unit === "week" && (
                    <FormGroup>
                      <Grid container spacing={1} style={{ padding: 15 }}>
                        {daysOfWeek.map((day) => (
                          <Grid item xs={4} key={day}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={props.recurrence?.[day]}
                                  onChange={props.handleDayChange}
                                  name={day}
                                  disabled={props.readOnly}
                                />
                              }
                              label={snakeCaseToTitleCase(day)}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </FormGroup>
                  )}
              </FormControl>
            </Grid>
            {props.recurrence?.repeat && (
              <Grid
                item
                xs={12}
                className="field-container"
                style={{
                  padding: "20px 0 20px 0",
                }}
              >
                <FormControl component="fieldset">
                  <b>This action should end</b>
                  <RadioGroup
                    aria-label="end_timing"
                    name="end_timing"
                    value={props.recurrence?.end_timing}
                    onChange={props.handleStringChange}
                    style={{gap: '16px'}}
                  >
                    <FormControlLabel
                      value={"after_n_occurences"}
                      control={<Radio />}
                      disabled={props.readOnly}
                      label={
                        <Box display="flex" alignItems="center">
                          <span>After: &nbsp;</span>
                          <TextField
                            id="occurences"
                            name="occurences"
                            type="text"                           
                            size="small"
                            value={props.recurrence?.occurences || ""}
                            className="the-field"
                            required
                            variant="outlined"
                            placeholder="Unit"
                            style={{ width: "5em", marginRight: "5px" }}
                            disabled={
                              props.readOnly ||
                              props.recurrence?.end_timing !== "after_n_occurences"
                            }
                            inputProps={{
                              maxLength: 10,                      
                              inputMode: "numeric",               
                              pattern: "[0-9]*"                   
                            }}
                            onChange={(e) => {
                              const raw = e.target.value;
                              const numeric = raw.replace(/\D/g, "");
                              const trimmed = numeric.slice(0, 10);
                              props.handleStringChange({
                                target: {
                                  name: "occurences",
                                  value: trimmed
                                }
                              });
                            }}
                          />
                          <span>&nbsp; occurrences</span>
                        </Box>
                      }
                    />
                    <FormControlLabel
                      value={"after_program_start_date"}
                      control={<Radio />}
                      disabled={props.readOnly}
                      label={
                        <Box display="flex" alignItems="center">
                          <TextField
                            id="end_after_program_start_value"
                            name="end_after_program_start_value"
                            type="text"                           
                            size="small"
                            value={props.recurrence?.end_after_program_start_value || ""}
                            className="the-field"
                            required
                            variant="outlined"
                            placeholder="Unit"
                            style={{ width: "5em", marginRight: "5px" }}
                            disabled={
                              props.readOnly ||
                              props.recurrence?.end_timing !== "after_program_start_date"
                            }
                            inputProps={{
                              maxLength: 10,                      
                              inputMode: "numeric",               
                              pattern: "[0-9]*"                   
                            }}
                            onChange={(e) => {
                              const raw = e.target.value;
                              const numeric = raw.replace(/\D/g, "");
                              const trimmed = numeric.slice(0, 10);
                              props.handleStringChange({
                                target: {
                                  name: "end_after_program_start_value",
                                  value: trimmed
                                }
                              });
                            }}
                          />
                          <TextField
                            id="end_after_program_start_unit"
                            name="end_after_program_start_unit"
                            onChange={props.handleStringChange}
                            size="small"
                            value={props.recurrence?.end_after_program_start_unit}
                            variant="outlined"
                            select
                            style={{ width: "6em", marginRight: "10px" }}
                            disabled={
                              props.readOnly ||
                              props.recurrence?.end_timing !==
                              "after_program_start_date"
                            }
                            className="the-field"
                          >
                            <MenuItem value="" disabled>
                              Select
                            </MenuItem>
                            {TIME_UNITS.map((time) => (
                              <MenuItem key={time} value={time}>
                                {time}(s)
                              </MenuItem>
                            ))}
                          </TextField>{" "}
                          after program start date
                        </Box>
                      }
                    />
                    <FormControlLabel
                      value={"no_end_date"}
                      control={<Radio />}
                      disabled={props.readOnly}
                      label={
                        <Box display="flex" alignItems="center">
                          No End Date
                        </Box>
                      }
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            )}
          </Grid>
  )
}

export default StandardRecurrenceForm